import { ContextAction } from '$context/global-context/types';
import useGlobalContext from '$hooks/use-global-context';

export const useLogout = () => {
  const { dispatch } = useGlobalContext();

  const logout = async (callback: (x?: any) => any) => {
    await callback();
    await dispatch({
      type: ContextAction.resetUser
    });

    await dispatch({
      type: ContextAction.resetPermissions
    });
  };

  return { logout };
};
